







































import { Component, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import { ClassState } from '@/api/models';
import SessionModule from '@/store/modules/session';
import classInfo from '@/components/common/classInfo.vue';
@Component({ components: { classInfo } })
export default class SignUpIndex extends Vue {
  solutionId: string = '';
  loading: boolean = false;
  finished: boolean = false;
  ClassesList: any[] = [];
  StudentAuditStatusList: any = [];

  get reportList() {
    return this.ClassesList.filter(e => e.studentAuditStatu === 1);
  }

  get noReportList() {
    return this.ClassesList.filter(e => e.studentAuditStatu === undefined);
  }

  async onLoad() {
    await this.getClasses();
  }

  async getClasses() {
    this.loading = true;
    try {
      const { data } = await api.ClassSolution.findClassSolutions_GET({
        state: ClassState.培训中,
      });

      if (data!.items) {
        let classIds: any = [];
        data!.items.forEach((item: any) => {
          classIds.push(item.id);
        });
        await this.getStudentAuditStatus(classIds, data!.items);
      }
    } finally {
      this.loading = false;
      this.finished = true;
    }
  }
  //获取学员对应培训班的报名审核状态
  async getStudentAuditStatus(classIds: any, dataList: any) {
    const { data } = await api.ClassSolution.getStudentAuditStatus_GET({
      studentId: SessionModule.getActiveSession.userId,
      classIds: classIds,
    });
    this.StudentAuditStatusList = data;
    dataList.forEach((classItem: any) => {
      this.StudentAuditStatusList.forEach((stuAuditItem: any) => {
        if (classItem.id == stuAuditItem.classId) {
          classItem.studentAuditStatu = stuAuditItem.studentAuditStatu;
        }
      });
      this.ClassesList.push(classItem);
    });
  }
  //报名成功回调，不刷新页面更新报名状态
  signUpSuccess(classItem: any) {
    this.ClassesList.forEach((item: any) => {
      if (item.id == classItem.id) {
        this.$set(item, 'studentAuditStatu', 1);
      }
    });
  }
}
